<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />
  </div>
</template>

<script>
import { Locale } from 'vant'
import enUS from 'vant/es/locale/lang/en-US'
import zhCN from 'vant/es/locale/lang/zh-CN'
export default {
  watch: {
    $route(val) {
      // console.log(val)
      if (this.$root.language !== val.params.language) {
        this.$root.language = val.params.language ? val.params.language : 'zh'
        this.$i18n.locale = this.$root.language
      }

      this.$root.currentPage = val.name

      if (!this.$root.firstPage) {
        this.$root.firstPage = val.name
      }
    },
    lang(val) {
      if (val == 'en') {
        Locale.use('en-US', enUS)
      } else {
        Locale.use('zh-CN', zhCN)
      }
    }
  },

  computed: {
    lang() {
      return this.$i18n.locale
    },
  },
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50; */
}

body {
  --background: #06f;
  --color: #fff;
}

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
